import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import axios from 'axios';
import moment from 'moment'
import VueElementLoading from 'vue-element-loading'
import excel from 'vue-excel-export'
import VueSocialSharing from 'vue-social-sharing'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueProgressBar from 'vue-progressbar'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import mixin from './mixin/helper' 
import VueYoutube from 'vue-youtube'


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY hh:mm')
  }
})

// Vue.config.silent = true;

const optionsProgressbar = {
  color: '#fff',
  failedColor: '#874b4b',
  thickness: '6px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(Loading);
Vue.use(VueProgressBar, optionsProgressbar)
Vue.use(VueSocialSharing);
Vue.use(excel)
Vue.use(VueFeather)
Vue.use(flatPickr)
Vue.use(VueYoutube)

Vue.use(VueRouter)
Vue.use(vco)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueSweetalert2);

Vue.component('apexchart', VueApexCharts)
Vue.component('VueElementLoading', VueElementLoading)

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

// axios.interceptors.request.use(
//   (config) => {
//     if (store.state.profile == null || store.state.profile == undefined || 
//       store.state.profile.token == null || store.state.profile.token == undefined || 
//       store.state.profile.token == '') { 
//     } else {
//       config.headers['Authorization'] = 'Bearer '+store.state.profile.token;
//     }
//     return config;
//   }, 

//   (error) => {
//     console.log(error);
//     return Promise.reject(error);
//   }
// );
// Uncomment this if you are having api served through other url or do not want to use fake backend
// Vue.prototype.$http = require('axios')
// Vue.prototype.$http.defaults.baseURL  = 'http://mock-api.coderthemes.com/'

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
